var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from "react";
import { buildCountryData, defaultCountries, FlagImage, parseCountry, usePhoneInput, } from "react-international-phone";
import { useTranslation } from "react-i18next";
import { InputAdornment, makeStyles } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import { usePortal } from "../../../../../Providers/PortalProvider";
const modifiedCountries = defaultCountries.map((country) => {
    const parsedCountry = parseCountry(country);
    if (parsedCountry.iso2 == "fi") {
        // One provider in finland have 10 digits?
        parsedCountry.format = {
            default: ".. ... .. ..",
            "/^457/": "... ... .. ..",
        };
    }
    return buildCountryData(parsedCountry);
});
const useStyles = makeStyles(() => ({
    phoneNumber: {
        "& input": {
            paddingLeft: "80px",
        },
        "&.three-digits-country-code input": {
            paddingLeft: "90px",
        },
        "& .MuiOutlinedInput-adornedStart": {
            paddingLeft: 0,
        },
    },
    countryPrefix: {
        fontSize: "14px",
        marginLeft: "4px",
        fontWeight: "bold",
    },
}));
const InputMobileNumber = (_a) => {
    var _b;
    var { field, form } = _a, restProps = __rest(_a, ["field", "form"]);
    const portal = usePortal();
    const [t] = useTranslation();
    const allowedCountries = useMemo(() => {
        const lowerCaseAllowedSMSCountryCodes = portal.options.allowedSMSCountryCodes.map((countryCode) => countryCode.toLowerCase());
        console.log("Lower case countries", lowerCaseAllowedSMSCountryCodes);
        return modifiedCountries.filter((dc) => lowerCaseAllowedSMSCountryCodes.indexOf(dc[1]) >= 0);
    }, []);
    const inputMobileValue = field.value.replace(/^[0\s]+/, "");
    const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } = usePhoneInput({
        defaultCountry: portal.locale.country.twoLetterCode.toLowerCase(),
        countries: modifiedCountries,
        // Trim existing zeros in case the number is "filled"
        value: inputMobileValue,
        onChange: (data) => {
            console.log("Data input value is ", data.inputValue);
            // If no input, make sure the field is empty
            if (!data.inputValue) {
                form.setFieldValue(field.name, "");
                return;
            }
            console.log("The input value", data);
            // Trim spaces and remove leading zeros
            // FIXME: May not always work if the number start with (+)country code
            const trimmedPhone = data.inputValue.trim().replace(/^[0\s]+/, "");
            const newNumber = "+" + data.country.dialCode + trimmedPhone;
            console.log("Set trimmed number", data, trimmedPhone, newNumber);
            form.setFieldValue(field.name, newNumber);
        },
        disableDialCodeAndPrefix: true,
    });
    const cleanupNumber = (number) => {
        return number.replace(/ /g, "").replace(/^0+/, "");
    };
    console.log("The country", country);
    // React int.mobile don't handle autofill/paste any good, try to fix it
    const handleNumberChange = (e) => {
        console.log("Preprocess number", e.target.value);
        let inputValue = e.target.value;
        // A lot of the problems is removed by removing leading zeros
        inputValue = cleanupNumber(inputValue);
        // We may also have leading zeros after the country prefix?
        console.log("Preprocess input value", inputValue);
        if (inputValue[0] === "+") {
            // Assume we have a valid country
            for (const allowedCountry of allowedCountries) {
                const countryCode = allowedCountry[2];
                if (inputValue.startsWith("+" + countryCode)) {
                    let mobileWithoutCountryCode = inputValue.substring(countryCode.length + 1);
                    mobileWithoutCountryCode = cleanupNumber(mobileWithoutCountryCode);
                    inputValue = "+" + countryCode + mobileWithoutCountryCode;
                    console.log("Found country for mobile", countryCode, inputValue, mobileWithoutCountryCode);
                }
                //const country = getCountry(allowedCountry);
                console.log("Allowed country", allowedCountry);
            }
        }
        e.target.value = inputValue;
        handlePhoneValueChange(e);
    };
    const classes = useStyles();
    console.log("Number field", field, form);
    return (React.createElement(TextField, Object.assign({ variant: "outlined", color: "primary", onChange: handleNumberChange, onBlur: field.onBlur, type: "tel", value: inputValue, name: field.name, inputRef: inputRef, className: `${classes.phoneNumber} ${country.dialCode.length === 3 ? "three-digits-country-code" : "two-digits-country-code"}`, error: form.touched[field.name] && !!form.errors[field.name], helperText: form.touched[field.name] && form.errors[field.name], InputProps: {
            startAdornment: (React.createElement(InputAdornment, { position: "start", style: {
                    position: "absolute",
                    left: "8px",
                    padding: 0,
                } },
                React.createElement(Select, { id: "input-mobile", MenuProps: {
                        style: {
                            height: "300px",
                            width: "360px",
                            top: "10px",
                            left: "-34px",
                        },
                        transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                        },
                    }, value: country.iso2, onChange: (e) => setCountry(e.target.value), inputProps: { "aria-label": (_b = t("Choose country")) !== null && _b !== void 0 ? _b : "" }, renderValue: (value) => {
                        const countryIso2Value = value;
                        console.log("Rendering flag with value", value);
                        return (React.createElement(FlagImage, { iso2: countryIso2Value, style: { display: "flex" } }));
                    } }, allowedCountries.map((c) => {
                    const country = parseCountry(c);
                    return (React.createElement(MenuItem, { key: country.iso2, value: country.iso2 },
                        React.createElement(FlagImage, { iso2: country.iso2, style: { marginRight: "8px", width: "24px" } }),
                        React.createElement(Typography, { style: { marginRight: "20px" } }, country.name),
                        React.createElement(Typography, { variant: "subtitle2" },
                            "+",
                            country.dialCode)));
                })),
                React.createElement("div", { className: classes.countryPrefix },
                    "+",
                    country.dialCode))),
        } }, restProps)));
};
export default InputMobileNumber;
